import { useState } from "react";
import Modal from "react-modal";
import { toast } from "react-toastify";
import { ISubscriptionInfo } from "../../../shared/interfaces/subscription-info";
import {
    cancelSubscription,
    reactivateSubscription,
} from "../../../shared/services/stripe/stripe.service";

interface IProps {
    subscriptionInfo: ISubscriptionInfo;
    showModal: boolean;
    onUpdate: () => void;
    setUpdateLoading: (loading: boolean) => void;
    onClose: () => void;
}

const CancelSubscriptionModal = ({
    subscriptionInfo,
    showModal,
    onUpdate,
    setUpdateLoading,
    onClose,
}: IProps) => {
    const [isMobile] = useState(window.outerWidth < 768);
    const cancelAtPeriodEnd = subscriptionInfo?.cancelAtPeriodEnd;

    const reactivateSub = async () => {
        setUpdateLoading(true);
        await reactivateSubscription();
        setUpdateLoading(false);
    };

    const cancelSub = async () => {
        setUpdateLoading(true);
        await cancelSubscription();
        setUpdateLoading(false);
        toast.success("Subscription Canceled");
    };

    const onConfirm = async () => {
        try {
            if (cancelAtPeriodEnd) {
                await reactivateSub();
                localStorage.setItem("reloadSubscription", "true");
                window.location.reload();
            } else {
                await cancelSub();
                onUpdate();
            }
        } catch (error) {
            toast.error(
                "Looks like something went wrong. Please try again later"
            );
        }
    };

    return (
        <Modal
            isOpen={showModal}
            style={{
                content: {
                    top: "35%",
                    left: "50%",
                    right: "auto",
                    bottom: "auto",
                    transform: "translate(-50%, -30%)",
                    width: isMobile ? "100%" : "40%",
                    minWidth: "300px",
                    maxWidth: "550px",
                    padding: "25px",
                    backgroundColor: "#FFFF",
                    borderRadius: "8px",
                },
            }}
        >
            <h2 className="text-4xl font-century-gothic-bold mb-4 text-center text-aha-black">
                {cancelAtPeriodEnd
                    ? "Reactivate Subscription"
                    : "We'll be sad to see you go"}
            </h2>
            <p className="mx-12 text-center text-aha-secondary-text text-lg mb-6 ">
                {cancelAtPeriodEnd
                    ? "Are you sure you want to reactivate your subscription?"
                    : "Cancelling your subscription will remove access to premium features."}

                {!cancelAtPeriodEnd && (
                    <>
                        <br />
                        Are you sure you want to cancel?
                    </>
                )}
            </p>
            <div className="flex justify-center gap-3">
                <button
                    onClick={() =>
                        cancelAtPeriodEnd ? onConfirm() : onClose()
                    }
                    className="bg-aha-orange border-0 text-white px-2 py-1.5 rounded-md text-sm w-full"
                >
                    {cancelAtPeriodEnd
                        ? "Reactivate Membership"
                        : "Keep My Membership"}
                </button>
                <button
                    onClick={() =>
                        cancelAtPeriodEnd ? onClose() : onConfirm()
                    }
                    className="text-aha-secondary-text border-2 border-aha-light-gray px-2 py-1 rounded-md text-sm w-full"
                >
                    {cancelAtPeriodEnd ? "Close" : "Cancel Membership"}
                </button>
            </div>
        </Modal>
    );
};

export default CancelSubscriptionModal;
